import { Title, PrimaryButton, Text, Box, Grid } from '../../ui';
import React from 'react';
import { useNavigationHandlers } from '@src/shared/hooks';

export type HeaderProps = {
  continueButton?: boolean;
  goToHome?: () => void;
  iconLeft?: 'help' | 'arrow-left';
  id?: string;
  step?: boolean;
};

export const Header: React.FC<HeaderProps> = ({
  continueButton,
  iconLeft,
  id,
  step = false,
}) => {
  const { toFaq, toHome } = useNavigationHandlers();
  const iconLeftSrc =
    {
      help: '/help-icon.svg',
      ['arrow-left']: '/arrow-left.svg',
    }[iconLeft] || '/help-icon.svg';

  const bgStep = step
    ? `
        sm:bg-[url('/bgHeader.png')]
        sm:bg-no-repeat
        sm:bg-right
        sm:bg-cover
        sm:min-h-[168px]
      `
    : '';

  return (
    <Grid
      id={id}
      className={`
          py-[${continueButton ? 18 : 26}px]
          z-0
          min-h-[84px]
          max-h-[84px]
          bg-brand-blue-midnight-30
          ${bgStep}
        `}
      autoRowsHeight
    >
      <Box
        className={`
            col-span-3
            sm:col-span-8
            md:col-span-6
            row-start-1
            flex
            justify-center
            flex-col
          `}
      >
        <Box
          className={`
            flex
            items-center
            flex-row
            min-w-[239.25px]
            xxs:min-w-[269.5px]
            max-w-full
          `}
        >
          <img
            src='/pagol-header.svg'
            alt='Pagol'
            className={`
            block
            h-[14px]
            min-[360px]:h-4
            my-1
            sm:h-6
          `}
          />
        </Box>
        {step && (
          <Title
            color='azulFuso30'
            fontSize='lg'
            lineHeight='base'
            fontWeight='regular'
            className='hidden sm:flex mt-4'
          >
            Parcele sua viagem sem precisar de cartão de crédito!
          </Title>
        )}
      </Box>
      {continueButton && (
        <PrimaryButton
          onClick={toHome}
          className={`
            hidden
            sm:flex
            sm:col-span-3
            sm:col-start-10
            sm:self-center
            sm:justify-self-end
            text-[16px]
            h-[48px]
            w-[252px]
            rounded-xl
            p-3
          `}
        >
          <Text
            color='white'
            fontSize='md'
            fontWeight='bold'
            className='w-[228px] p-0 m-0'
          >
            Continuar parcelamento
          </Text>
        </PrimaryButton>
      )}
      {iconLeft && (
        <img
          src={iconLeftSrc}
          onClick={iconLeft === 'arrow-left' ? () => toHome() : toFaq}
          alt='help'
          id='button-faq'
          className={`
          hover:cursor-pointer
          sm:hidden
          h-6 
          row-start-1
          col-start-4
          self-center
          justify-self-end
        `}
        />
      )}
      {step && (
        <img
          src='/stepperImage.svg'
          alt='Representação de um Stepper'
          className={`
            hidden
            md:flex
            md:col-span-6
            min-[1279px]:min-w-[515px]
            md:justify-self-end
            md:col-end-13
            md:self-center
          `}
        />
      )}
    </Grid>
  );
};
